import React, {PropsWithChildren, useState} from 'react';
import {VehiclesType} from '../../types/data';

export type VehicleContextType = {
  value: VehiclesType[] | null;
  set: (data: VehiclesType[]) => void;
};

export const VehicleContext = React.createContext<VehicleContextType | null>(
  null,
);

export const VehicleContextProvider = (props : PropsWithChildren) => {
  const [vehicles, setVehicles] = useState<VehiclesType[] | null>(null);

  const setVehiclesSorted = (data: VehiclesType[]) => {
    const dataSorted = data
      .slice()
      .sort((d) => (d.Make == 'Volkswagen' ? 1 : -1));
    setVehicles(dataSorted);
  };

  const VehicleContextValue: VehicleContextType = {
    value: vehicles,
    set: setVehiclesSorted,
  };

  return (
    <VehicleContext.Provider value={VehicleContextValue}>
      {props.children}
    </VehicleContext.Provider>
  );
};
